import React, {createContext, useContext, useMemo, useState} from "react";
import oneLogoWhite from "../assets/images/one_logo_white.svg";
import oneSolutions from "../assets/images/one_solutions.svg";
import twoConnectLogoWhite from "../assets/images/2connect_short_logo_RGB_white.png";
import twoConnectLogoLightBg from "../assets/images/2connect_long_logo_RGB_lightBG.png";
import {createTheme} from "@mui/material/styles";
import {oneThemeSettings} from "../theme/oneThemeSettings";
import {twoConnectThemeSettings} from "../theme/2connectThemeSettings";
import useInjectFonts from "../theme/useInjectFonts";
import twoConnectEn from "../languages/2connect/en";
import twoConnectHu from "../languages/2connect/hu";
import oneHu from "../languages/one/hu";
import oneEn from "../languages/one/en";
import useInjectFavicon from "../theme/useInjectFavicon";
import useInjectTitle from "../theme/useInjectTitle";

export const CompanyEnvironmentContext = createContext({
  companyEnvironment: window._env_.REACT_APP_COMPANY,
  logos: undefined,
  theme: undefined,
  contact: {
    phoneNumber: window._env_.REACT_APP_CONTACT_PHONE_NUMBER,
    foreignPhoneNumber: window._env_.REACT_APP_CONTACT_FOREIGN_PHONE_NUMBER,
    mail: window._env_.REACT_APP_CONTACT_MAIL
  }
});

const CompanyEnvironmentProvider = props => {
  const companyEnvironmentContext = useContext(CompanyEnvironmentContext);
  const [companyEnvironment, setCompanyEnvironment] = useState(companyEnvironmentContext.companyEnvironment);
  const [contact, setContact] = useState(companyEnvironmentContext.contact);

  const companyData = useMemo(() => {
    switch (companyEnvironment) {
      case "2connect":
        return {
          fontPaths: "/font/2connect/fonts.css",
          favIcon: "/2connect_short_logo_RGB.png",
          title: "2Connect Business Portal",
          theme: createTheme(twoConnectThemeSettings),
          logos: {
            fullWhite: twoConnectLogoWhite,
            fullLightBg: twoConnectLogoLightBg
          },
          dictionaries: {
            en: twoConnectEn,
            hu: twoConnectHu
          }
        };
      case "one":
      default:
        return {
          fontPaths: "/font/one/fonts.css",
          favIcon: "/one.svg",
          title: "One Solutions Business Portal",
          theme: createTheme(oneThemeSettings),
          logos: {
            fullWhite: oneLogoWhite,
            fullLightBg: oneSolutions
          },
          dictionaries: {
            en: oneEn,
            hu: oneHu
          }
        };
    }
  }, [companyEnvironment]);

  useInjectFonts(companyData.fontPaths);

  useInjectFavicon(companyData.favIcon);

  useInjectTitle(companyData.title);

  const provider = {
    companyEnvironment: companyEnvironment,
    logos: companyData.logos,
    theme: companyData.theme,
    dictionaries: companyData.dictionaries,
    contact: contact
  };

  return (
    <CompanyEnvironmentContext.Provider value={provider}>
      {props.children}
    </CompanyEnvironmentContext.Provider>
  );
};

export default CompanyEnvironmentProvider;
